import BdcInvoiceRegister from "../components/Bdc/Invoice/Register";

const BdcInvoicesPage = () => <BdcInvoiceRegister />;

export default BdcInvoicesPage;
